import {alert} from './alerts';

export function checkPhone(phone, notUA) {
    phone = phone.replace(/[^0-9]+/gim, '');

    if (phone.length !== PHONE_LENGTH) {
        // Номер телефона должен содержать * цифр
        alert(trans('common.phone_length', {length: PHONE_LENGTH}), trans('common.enter_phone_caption'));
        return false;
    }

    if (COUNTRY === 'UA' && notUA !== 1) {
        if (mCodArr.indexOf(phone[0] + phone[1] + phone[2]) !== -1) {
            // It's mobile phone
            return true;
        }

        // Необходимо указать номер мобильного телефона
        alert(trans('common.enter_phone'), trans('common.enter_phone_caption'));
        return false;
    }

    // Not Ukrainian number
    return true;
}

export function checkEmail(email) {
    email = $.trim(email);

    if (email === 'empty' && typeof IS_OFFICE !== 'undefined' && IS_OFFICE) {
        return true;
    }

    if (email.length < 5) {
        // Введите Вашу електронную почту в соответсвующем поле
        alert(trans('common.enter_email'), trans('common.empty_email_caption'));
        return false;
    }

    if (!/^[-0-9a-z_\.]+@[-0-9a-z_^\.]+\.[a-z]{2,6}$/i.test(email)) {
        // E-mail может содержать только английские буквы, цифры, точки, а также символ «@»
        alert(trans('common.email_format_message'), trans('common.email_format_caption'));
        return false;
    }

    return true;
}
